import "./TableLabels.scss";

interface TableLabelsProps {
  totalPages: number;
  currentPage: number;

  setCurrentPage: (page: number) => void;
}

const TableLabels = (props: TableLabelsProps) => {
  const arrayBtn = [];
  if (props.totalPages > 7 && props.currentPage > 4) {
    arrayBtn.push(
      <div key="page-btn-first" className="pagination-btn more">
        ...
      </div>
    );
  }
  for (let i = 1; i <= props.totalPages; i++) {
    if (
      (i > props.currentPage + 3 && i < 8) ||
      (i >= props.currentPage - 3 && i <= props.currentPage + 3) ||
      (i < props.currentPage - 3 && i > props.totalPages - 7)
    ) {
      arrayBtn.push(
        <div
          key={"page-btn-" + i}
          className={
            "pagination-btn" + (props.currentPage === i ? " active" : "")
          }
          onClick={() => {
            if (props.currentPage !== i) props.setCurrentPage(i);
          }}
        >
          {i}
        </div>
      );
    }
  }
  if (props.totalPages > 7 && props.currentPage <= props.totalPages - 4) {
    arrayBtn.push(
      <div key="page-btn-last" className="pagination-btn more">
        ...
      </div>
    );
  }
  return <>{arrayBtn}</>;
};

export default TableLabels;
